module.exports = __webpack_public_path__ + "static/hero_about-8d3ff9db548fe14fea9d3a7d5cb9272a.png";